import React from 'react';
import { useTranslation } from 'react-i18next';

import { selectCountry } from 'store/user/selectors';
import { selectCancellationCandidate } from 'store/subscriptions/selectors';
import { setCancellationCandidate } from 'store/subscriptions/actions';
import { openModal, closeModal } from 'store/modals/actions';

import { useSelector, useDispatch } from 'react-redux';

import { normalizeDateByLocale } from 'pages/AccountSettings/components/SubscriptionsTab/components/SubscriptionCard/helpers';

import AlertModal from 'modals/AlertModal';

import { ModalName } from 'types/modals';

const AlertModalContainer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const country = useSelector(selectCountry);
  const cancellationCandidate = useSelector(selectCancellationCandidate);
  const expirationDate = normalizeDateByLocale(cancellationCandidate.expired_date, country);

  const onSubmit = () => {
    dispatch(openModal(ModalName.FREEZE_ALERT_MODAL));
  };

  const discardCancellationHandler = () => {
    dispatch(closeModal());

    dispatch(setCancellationCandidate(null));
  };

  return (
    <AlertModal
      onDiscard={discardCancellationHandler}
      onSubmit={onSubmit}
      captions={{
        title: t('subscription.cancelDialog.title'),
        description: t('subscription.cancelDialog.description', { date: expirationDate }),
        submitButton: t('subscription.text.cancel'),
        discardButton: t('subscription.cancelDialog.discard'),
      }}
      dataLocator="cancelSubModal"
    />
  );
};

export default AlertModalContainer;
